// testThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Post, SecureGet, SecurePost, } from "../services/axiosCall";
import apis from "../services/Apis";
import Alert from "../components/common/alert";

export let parse_time = (d) => {
  var m_left = Math.floor(d / 60);
  var s_left = Number(String(d % 60).slice(0, 2));
  return {
    m_left: m_left,
    s_left: s_left,
  };
};
// Async thunk
export const fetchTestTableData = createAsyncThunk(
  "test/getTestTableData",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SecurePost({
        url: apis.ALL_TEST_STUDENT,
        data,
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const fetchTestdata = createAsyncThunk(
  "trainer/fetchTestdata",
  async ({ testid, traineeid }, { rejectWithValue }) => {
    // console.log(testid, traineeid);
    try {
      const response = await Post({
        url: apis.FETCH_TRAINEE_TEST_DETAILS,
        data: {
          testid,
          traineeid,
        },
      });

      if (response.data.success) {
        const data = response.data.data;
        //  console.log(data);

        let result = {
          testbegins: data.testbegins,
          startedWriting: data.startedWriting,
          testconducted: data.testconducted,
          completed: data.completed,
        };

        if (!data.completed && data.startedWriting) {
          const t = parse_time(data.pending);
          result.m_left = t.m_left;
          result.s_left = t.s_left; // optional: include t.m_left, t.s_left
        }
        // console.log(result);

        return result;
      } else {
        return rejectWithValue("Invalid URL or data");
      }
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Unknown error";
      return rejectWithValue(message);
    }
  }
);

export const proceedToTest = createAsyncThunk(
  "test/proceedToTest",
  async ({ testId, userId }, { rejectWithValue }) => {
    try {
      const response = await Post({
        url: apis.PROCEED_TO_TEST,
        data: {
          testid: testId,
          userid: userId,
        },
      });

      if (!response.data.success) {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
      // console.log("data",response.data);

      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const fetchTraineedata = createAsyncThunk(
  "trainee/fetchLoggedInTrainee",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Post({
        url: apis.FETCH_TRAINEE_DETAILS,
        data: { _id: id },
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const fetchTraineeTestQuestions = createAsyncThunk(
  "traineeTest/fetchQuestions",
  async (tid, { rejectWithValue }) => {
    // console.log(tid);

    try {
      const response = await Post({
        url: apis.FETCH_TRAINEE_TEST_QUESTION,
        data: { id: tid },
      });
      if (response.data.success) {
        // console.log(response.data);

        return {
          questions: response.data.data,
          title: response.data.title,
        };
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const fetchTraineeTestAnswerSheet = createAsyncThunk(
  "traineeTest/fetchAnswerSheet",
  async ({ testid, userid }, { rejectWithValue }) => {
    // console.log(testid,userid);

    try {
      const response = await Post({
        url: apis.FETCH_TRAINEE_TEST_ANSWERSHEET,
        data: {
          testid,
          userid,
        },
      });

      if (response.data.success) {
        const processedAnswers = response?.data?.data?.answers?.map((d) => {
          if (d.chosenOption?.length !== 0) {
            return { ...d, isMarked: false, isAnswered: true };
          } else if (d.customAnswer !== undefined && d.customAnswer !== "") {
            return { ...d, isMarked: false, isAnswered: true };
          } else {
            return { ...d, isMarked: false, isAnswered: false };
          }
        });
        // console.log(processedAnswers);

        return processedAnswers;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);

export const fetchStudentHistory = createAsyncThunk(
  "studentHistory/fetchStudentHistory",
  async (title, { rejectWithValue }) => {
    // console.log(title);

    try {
      const response = await SecurePost({
        url: `${apis.STUDENT_HISTOREY}`,
        data: title,
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        Alert("error", "Error!", response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      Alert("error", "Error!", message);
      return rejectWithValue(message);
    }
  }
);
